import AnimatedDupeLogo from '~/src/components/AnimatedDupeLogo'
import { cn } from '~/src/lib/utils'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  forceTheme?: 'dark' | 'light'
}

const DupeHero: React.FC<Props> = ({ forceTheme, className, ...props }) => {
  return (
    <div
      className={cn(
        'flex w-full flex-col items-center space-y-2 md:space-y-4',
        className
      )}
      {...props}
    >
      <h1 className='sr-only'>Dupe.com</h1>
      <AnimatedDupeLogo forceTheme={forceTheme} />
      <div className='text-center text-xl font-semibold tracking-tighter md:text-3xl'>
        Find similar products for less
      </div>
    </div>
  )
}

export default DupeHero
